import axios from 'axios';
import consts from "@/consts"
import config from "@/config"
import store from '@/store'
import i18n from '@/i18n'
import {sendError} from "@/api/error-report";

let baseURL = config.api.baseURL
const instance = axios.create({
    baseURL,
    headers: {
        "Content-type": "application/json",
    }
})

instance.defaults.timeout = consts.api.defaults.auth.timeout;

let sessionAbortController = new AbortController()
const abortedSessionSignals = new WeakSet()
export function abortRequests() {
    abortedSessionSignals.add(sessionAbortController.signal)
    sessionAbortController.abort()
    sessionAbortController = new AbortController()
}

instance.interceptors.request.use(
    (config) => {
        //const token = this.$cookies.get('token')
        //const token = localStorage.getItem(process.env.VUE_APP_PRODUCT+'.authtoken');
        //const token = store.state.security.tokens.access_token
        config.headers['Authorization'] = store.getters.getHeaderAuthorization;
        config.headers['X-Accept-Language'] = i18n.global.locale || 'en'
        if (!config.signal) config.signal = sessionAbortController.signal
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        // if (response.status === 200) {
        //     return response;
        // }
        // return Promise.reject(response);
        return response;
    },
    error => {
        if (abortedSessionSignals.has(error?.config?.signal)) {
            return new Promise(() => {})
        }
        if (error) {
            let status = error.response?.status || 0
            if (status === 401) {
                //if(store.state.security.tokens) {
                    store.commit('updateTokens', {})
                //}
                if(!(['/login','/logout','/site/logout']).includes(location.pathname)) {
                    window.location.href = window.location.origin + '/site/logout'
                }
            }
            store.commit('addRequestError', error)
        }
        sendError({
            timestamp: new Date().toISOString(),
            type: 'request',
            status: error.response?.status,
            method: error.config?.method,
            url: error.config?.url,
            response: error.response?.data,
            message: error.message,
        })

        return Promise.reject(error);
    }
);

export default instance;